module.exports = __webpack_public_path__ + "pc/img/body_basic-11.fa0b3a59.png";